import { cloneDeep, toNumber } from "lodash";
import React, { useEffect, useState } from "react";
import LineChart from "../../shared/components/LineChart/LineChart";
import sensorIcon from '../../assets/Images/sensor32.png';
import backIcon from '../../assets/Images/Back_16.png';
import { FormattedMessage, injectIntl } from "react-intl";
import { formatMessage } from "../../translations/connectedIntlProvider";
import RoutesConstants from "../../shared/components/Routes/routes.constants";
import { useDispatch, useSelector } from "react-redux";
import IState from "../../core/models/IState";
import { allSensorDataChart } from '../../core/selectors/sensorDataChart.selector';
import * as actions from '../../core/actions/actions';
import { initOptions } from "./SensorDataLineChart.type";
import AddSensorColumnPopupHOC from "../SensorData/hoc/AddSensorColumnPopupHOC";
import AddSensorColumn from "../SensorData/AddSensorColumn";
import moment from "moment";
import config from '../../helpers/config.helper';
import modelEnum from "../../constants/model.enum";
import userSettingEnum from "../../constants/userSetting.enum";
import ChartSetting from "./ChartSetting";
import ChartSettingPopupHOC from "./hoc/ChartSettingPopupHOC";
import './SensorDataLineChart.css';

const appConfig = config();
const dateFormat = appConfig.REACT_APP_DATE_FORMAT;

const SensorDataLineChart = (props: any) => {
    /* eslint-disable jsx-a11y/anchor-is-valid */
    const dispatch = useDispatch();
    const { sensorDataChartList }: any = useSelector((state: IState) => { return state.sensorDataChart });
    const { columnLists, dataRange }: any = useSelector((state: IState) => { return state.column });
    const language = useSelector((state: IState) => { return state.preferences.language })
    const allChartSensorData: any = useSelector(allSensorDataChart);
    let chartCollection: any = [];
    const [charts, setCharts] = useState<any>([]);
    const [dataRangeFlag, setDataRangeFlag] = useState<boolean>(false);
    const [columnListFlag, setColumnListFlag] = useState<boolean>(false);
    const [range, setRange] = useState<any>();
    const [EndDate, setEndDate] = useState<any>();
    const [endDateDisabled, setEndDateDisabled] = useState(false);
    //const [newUserMessage,setNewUserMessage] = useState(true);
    let chartPostData: any = { ICCID: '', Model: 0, KPIs: [], StartDate: '', EndDate: '' };
    const model = props.location.state ? props.location.state.model : '';
    const iccid = props.location.state ? props.location.state.iccid : '';

    const GetChartData = (date: any, range: any, isTillDate: boolean) => {
        var endDate = new Date();
        if (isTillDate === false)
            endDate = date;
        var newDate = new Date(endDate);
        newDate.setDate(newDate.getDate() - toNumber(range));
        chartPostData.ICCID = iccid;
        chartPostData.Model = model;
        chartPostData.KPIs = columnLists.columns !== undefined ? (columnLists.columns.Value ? JSON.parse(columnLists.columns.Value) : []) : [];
        if(chartPostData?.KPIs.length === 0 ) return;
        chartPostData.EndDate = moment(endDate).format(dateFormat) + " 23:59:59";
        chartPostData.StartDate = moment(newDate).format(dateFormat) + " 00:00:00";
        dispatch(actions.getSensorDataChart(chartPostData));
    }

    const GetLineChartColumns = () => {
        switch(model.toLowerCase()){
            case modelEnum.AQS.toLowerCase() :
                dispatch(actions.getUserSetting(userSettingEnum.LineChartColumnAQS));
                break;
            case modelEnum.FDS.toLowerCase():
                dispatch(actions.getUserSetting(userSettingEnum.LineChartColumnFDS));
                break;
            case modelEnum.AQS2.toLowerCase():
                dispatch(actions.getUserSetting(userSettingEnum.LineChartColumnAQS2));
                break;    
            case modelEnum.FDS2.toLowerCase():
                dispatch(actions.getUserSetting(userSettingEnum.LineChartColumnFDS2));
                break;
            case modelEnum.TIS.toLowerCase():
                dispatch(actions.getUserSetting(userSettingEnum.LineChartColumnTIS));
                break;
            case modelEnum.PS.toLowerCase():
                dispatch(actions.getUserSetting(userSettingEnum.LineChartColumnPS));
                break;
            default:        
                dispatch(actions.getUserSetting(userSettingEnum.LineChartColumnAQS3));
        }
        // if (model.toLowerCase() === modelEnum.AQS.toLowerCase()) {
        //     dispatch(actions.getUserSetting(userSettingEnum.LineChartColumnAQS));
        // } else {
        //     dispatch(actions.getUserSetting(userSettingEnum.LineChartColumnFDS));
        // }
    }

    const GetDataRange = () => {
        dispatch(actions.getDataRange(userSettingEnum.DataRange));
    }

    useEffect(() => {
        dispatch(actions.resetUserSettingState());
        dispatch(actions.resetDataRangeState());
        GetLineChartColumns();
        // GetDataRange();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        refreshChartClickHandler()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [language])

    useEffect(() => {
        if (columnLists.success) {
            if (columnLists.columns === "")
                setColumnListFlag(true);
            GetDataRange();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [columnLists.success]);

    useEffect(() => {

        if (dataRange.success) {
            if (dataRange.data === "")
                setDataRangeFlag(true);
            if (dataRange.data.Value) {
                var rangeData = JSON.parse(dataRange.data.Value);
                setRange(rangeData.range);
                setEndDate(rangeData.EndDate);
                setEndDateDisabled(rangeData.isTillDate);
                GetChartData(rangeData.EndDate, rangeData.range, rangeData.isTillDate);
            }
            setCharts([]);
            dispatch(actions.resetDataRangeState())
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataRange.success]);
    // useEffect(() => {
    //     if (columnLists.success) {
    //         GetChartData();
    //         setCharts([]);
    //     }
    // }, [dataRange.success]);

    useEffect(() => {
        if (sensorDataChartList.success) {
            //setNewUserMessage(false);
            setColumnListFlag(false);
            setDataRangeFlag(false);
            createChart();
            dispatch(actions.resetGetSensorDataChartSuccessState());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sensorDataChartList.success]);


    // useEffect(() => {
    //     if (EndDate && range && columnLists.success === true && chartPlotFlag) {
    //         if(columnLists.columns !== "")
    //             GetChartData(EndDate,range, endDateDisabled);
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [EndDate, range, endDateDisabled]);

    const getModePrefix = () =>{
        switch(model.toLowerCase()){
            case modelEnum.AQS2.toLowerCase():
                return modelEnum.AQS2.toLowerCase(); 
            case modelEnum.FDS2.toLowerCase():
               return modelEnum.FDS2.toLowerCase();
            case modelEnum.TIS.toLowerCase():
                return modelEnum.TIS.toLowerCase();
            case modelEnum.PS.toLowerCase():
                return modelEnum.PS.toLowerCase();
            case modelEnum.AQS3.toLowerCase():
                return modelEnum.AQS3.toLowerCase();
            default: 
                return '';
        }
    }

    const createChart = () => {
        if (!allChartSensorData?.ChartData) return;

        const xAxisInterval = getXAxisLabelInterval(1, range);
        const modePrefix = getModePrefix();

        const chartHeight =
            allChartSensorData.ChartData.length > 2 ? 260 : 550;

        const chartsData = allChartSensorData.ChartData.map((element: any) => {
            const dataPoints = element.Data.map((item: any) => ({
                x: new Date(item.XAxisValue),
                y: item.YAxisValue,
            }));

            const xValues = dataPoints.map((d:any) => d.x.getTime());

            const minX = new Date(Math.min(...xValues));
            const maxX = new Date(Math.max(...xValues));

            return {
            ...initOptions,
            height: chartHeight,

            title: {
                ...initOptions.title,
                text: formatMessage(modePrefix + element.KPIName),
            },

            axisX: {
                ...initOptions.axisX,
                interval: xAxisInterval,
                minimum: minX,
                maximum: maxX,
            },

            axisY: {
                ...initOptions.axisY,
                title: formatMessage(element.KPIUnit),
            },

            data: [
                {
                ...initOptions.data[0],
                dataPoints,
                },
            ],
            culture: language === "en" ? "en" : "jp",
            };
        });
        setCharts(chartsData);
    };

    const getXAxisLabelInterval = (chartCount: number, range: String) => {
        if (chartCount > 0) { //Handle the case when we have 2 charts
            var days = Number(range);
            if (!isNaN(days)) {
                return Math.ceil(days / 15);
            }
        }
        return 2;
    }

    const refreshChartClickHandler = () => {
    let tempKPIs = columnLists.columns !== undefined
      ? (columnLists.columns.Value ? JSON.parse(columnLists.columns.Value) : [])
      : [];
    if(tempKPIs.length == 0) return;
        setCharts([]);
        if (!(EndDate === undefined || range === undefined))
            GetChartData(EndDate, range, endDateDisabled);
    }

    const backToSensorDataHandler = () => {
        dispatch(actions.resetUserSettingState());
        dispatch(actions.resetGetSensorDataChartState());
        props.history.push({
            pathname: RoutesConstants.SensorData,
            state: {
                iccid: iccid,
                model: model,
                building: props.location.state.building,
                location: props.location.state.location,
                floor: props.location.state.floor,
                customerId:props.location.state.customerId,
                room:props.location.state.room
            }
        });
    }

    const openChartSetting = () => {
        props.chartSettingToggleHandler();
    }

    const openAddColumn = () => {
        props.addSensorColumToggleHandler();
    }

    const onColumnSave = () => {
        GetLineChartColumns();
    }
    const onDataSave = (values: any) => {
        if (values) {
            setRange(values.range);
            setEndDate(values.EndDate);
            setEndDateDisabled(values.isTillDate);
            if (columnLists.columns !== "")
                GetChartData(values.EndDate, values.range, values.isTillDate);
            //GetLineChartColumns();
        }

    }

    return (
        <React.Fragment>
            {
                props.showChartSettingPopup &&
                <ChartSetting
                    range={range}
                    EndDate={EndDate}
                    isTillDate={endDateDisabled}
                    onDataSave={onDataSave}
                    modalClosed={props.chartSettingToggleHandler} />
            }
            {
                props.showAddSensorColumnPopup &&
                <AddSensorColumn
                    from='LineChart'
                    model={model}
                    columnSave={onColumnSave}
                    modalClosed={props.addSensorColumToggleHandler} />
            }
            <div className="icon-nav navbar-fixed-top device-nav-bar text-left">
                <div className="container-fluid">
                    <div className="filter-left-area">
                        <ul>
                            <li><h1><img src={sensorIcon} alt=""></img> <FormattedMessage id='Sensor_Data_Chart' /> {" - "}  <FormattedMessage id='Sensor_Label_ICCID' />: {" " + iccid} </h1></li>
                        </ul>
                    </div>
                    <div className="add-list float-right">
                        <ul>
                            <li title={formatMessage('Back')}>
                                <a data-toggle="modal" onClick={() => backToSensorDataHandler()}>
                                    <img src={backIcon} alt="back"></img>
                                </a>
                            </li>
                            <li title={formatMessage('Data_Range')}>
                                <a data-toggle="modal" onClick={() => openChartSetting()} data-target="#addSensor">
                                    <i className="fa fa-cog"></i>
                                </a>
                            </li>
                            <li title={formatMessage('Select_KPI')}>
                                <a data-toggle="modal" onClick={() => openAddColumn()} data-target="#addSensor">
                                    <i className="material-icons">view_day</i>
                                </a>
                            </li>
                            <li title={formatMessage('Refresh')}>
                                <a data-toggle="modal" onClick={() => refreshChartClickHandler()}>
                                    <svg width="16" height="16" fill="currentColor" className="bi bi-arrow-repeat" viewBox="0 0 16 16">
                                        <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
                                        <path fillRule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z" />
                                    </svg>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {
                (dataRangeFlag || columnListFlag) &&
                <div><p><FormattedMessage id='New_User_Chart_Message' /></p></div>
            }
            <div id="line-chart" className="row">
                {
                    charts.map((option: any, index: number) => {
                        return (
                            <div key={index} className={charts.length > 1 ? "col-sm-6 mb-4 ipadchart" : "col-sm-12 mb-4"}>
                                <LineChart index={index} options={option}></LineChart>
                            </div>)
                    })
                }
            </div>
        </React.Fragment>
    );
};

export default injectIntl(ChartSettingPopupHOC(AddSensorColumnPopupHOC(SensorDataLineChart)));